import {Card, FormLayout, TextField} from "@shopify/polaris"
import {useStore} from "../container"

const TitleCard = ({error = []}) => {
	const {state, dispatch} = useStore()
	const {title} = state
	const handleChange = (key, value) => {
		dispatch({type: 'setData', payload: {[key]: value}})
	}

	return (
		<Card sectioned title={'Title'}>
			<FormLayout>
				<TextField
					label={'Title'}
					labelHidden
					value={title}
					onChange={v => handleChange('title', v)}
					error={error.includes('title')}
					placeholder={'Countdown for men\' clothing'}
			 />
			</FormLayout>
		</Card>
	)
}

export default TitleCard
